export const MANAGED_SSE_HANDSHAKE_EVENT = ":connect";
